/* eslint-disable no-case-declarations */
import BLUETOOTH_STATUS from 'constants/bluetooth';
import { VIDEO_CLASS_STATE } from 'constants/video';

export const INITIALIZE_PLAYER_ATTRIBUTES = 'classpass/video/INITIALIZE_PLAYER_ATTRIBUTES';
export const RESET_DEVICE = 'classpass/video/RESET_DEVICE';
export const RESET_VIDEO_PLAYER = 'classpass/video/RESET_VIDEO_PLAYER';
export const TOGGLE_CAST = 'classpass/video/TOGGLE_CAST';
export const TOGGLE_CONTROLS = 'classpass/video/TOGGLE_CONTROLS';
export const TOGGLE_INITIAL_PLAY = 'classpass/video/TOGGLE_INITIAL_PLAY';
export const UPDATE_DEVICE = 'classpass/video/UPDATE_DEVICE';
export const UPDATE_PERCENT_PLAYED = 'classpass/video/UPDATE_PERCENT_PLAYED';
export const VIDEO_COMPLETED = 'classpass/video/VIDEO_COMPLETED';
export const SET_VIDEO_MODE = 'classpass/video/SET_VIDEO_MODE';

export const getInitialState = () => ({
  bitrate: false,
  casted: false,
  castIntro: false,
  completed: false,
  controlsVisible: true,
  device: {
    bpm: 0,
    calories: 0,
    connection: false,
    classState: VIDEO_CLASS_STATE.SCHEDULED,
    currentZone: {
      name: 'Rest',
      percentage: 0,
      zone: 0,
    },
    disconnected: false,
    enabled: false,
    leaderboard: {
      collapsed: false,
      participants: [],
    },
    name: '',
    points: 0,
    status: BLUETOOTH_STATUS.UNINITIALIZED,
    targetZone: {
      min_percent: 0,
      max_percent: 0,
    },
  },
  featured: [],
  playhead: 0,
  percentPlayed: new Array(100).fill(0),
  started: false,
});

export const intializePlayerAttributes = (videoId, msa, duration) => ({
  type: INITIALIZE_PLAYER_ATTRIBUTES,
  videoId,
  msa,
  duration,
});
export const resetDevice = () => ({ type: RESET_DEVICE });
export const resetVideoPlayer = () => ({ type: RESET_VIDEO_PLAYER });
export const toggleCast = casted => ({ type: TOGGLE_CAST, casted });
export const toggleControls = visible => ({ type: TOGGLE_CONTROLS, visible });
export const toggleInitialPlay = () => ({ type: TOGGLE_INITIAL_PLAY });
export const updateDevice = device => ({ type: UPDATE_DEVICE, device });
export const updatePercentPlayed = currentTime => ({ type: UPDATE_PERCENT_PLAYED, currentTime });
export const videoCompleted = () => ({ type: VIDEO_COMPLETED });
export const setVideoMode = (mode, details) => ({ type: SET_VIDEO_MODE, mode, details });

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case INITIALIZE_PLAYER_ATTRIBUTES:
      return {
        ...state,
        videoId: action.videoId,
        msa: action.msa,
        duration: action.duration,
      };
    case UPDATE_DEVICE:
      return {
        ...state,
        device: {
          ...state.device,
          ...action.device,
          currentZone: {
            ...state.device.currentZone,
            ...action.device.currentZone,
          },
          leaderboard: {
            ...state.device.leaderboard,
            ...action.device.leaderboard,
          },
          targetZone: {
            ...state.device.targetZone,
            ...action.device.targetZone,
          },
        },
      };
    case UPDATE_PERCENT_PLAYED:
      const segment = Math.round((action.currentTime / state.duration) * 100);
      const percentPlayed = state.percentPlayed.slice(0); // TODO: Fix? -- Every click will automatically increment a percent
      percentPlayed[segment] = 1;
      return {
        ...state,
        playhead: action.currentTime,
        percentPlayed,
      };
    case TOGGLE_CAST:
      return {
        ...state,
        casted: action.casted,
      };
    case TOGGLE_CONTROLS:
      return {
        ...state,
        controlsVisible: action.visible,
      };
    case TOGGLE_INITIAL_PLAY:
      return {
        ...state,
        started: true,
      };
    case VIDEO_COMPLETED:
      return {
        ...state,
        started: false,
        completed: true,
        percentPlayed: new Array(100).fill(0),
      };
    case RESET_VIDEO_PLAYER:
      const reset = getInitialState();
      return {
        ...reset,
        device: {
          ...state.device,
        },
      };
    case RESET_DEVICE:
      const deviceReset = getInitialState().device;
      return {
        ...state,
        device: {
          ...deviceReset,
        },
      };
    case SET_VIDEO_MODE:
      return {
        ...state,
        detailMode: action.mode,
        details: action.details,
      };
    default:
      return state;
  }
}
